var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#202d40;}.cls-2{fill:#bdc3c8;}.cls-3{fill:#c0402b;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gtasks"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 230
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 50,
    rx: 21.82,
    transform: "translate(-115.66 270.26) rotate(-45)",
    width: 346.98,
    x: 94.91,
    y: 249.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 105.42,
    cy: 321.76,
    r: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.21888eb69f3827aec73189361eab4a9b.svg";
export { ForwardRef as ReactComponent };